import styled, { css } from 'styled-components';

import { Flex } from '@/components/Flex';
import LinkWithLocale from '@/components/LinkWithLocale/LinkWithLocale';

export const Tabs = styled(Flex)`
  flex-wrap: wrap;
  justify-content: center;
  margin-bottom: ${({ theme }) => theme.spacing(2)};
`;

export const Tab = styled(LinkWithLocale)<{ $isActive: boolean }>`
  all: unset;
  text-transform: uppercase;
  white-space: nowrap;
  cursor: pointer;

  ${({ $isActive, theme }) => css`
    font-family: ${theme.fontFamilies.italianPlate};
    font-size: ${theme.fontSizes.h6};
    color: ${$isActive ? theme.colors.primary : theme.colors.primaryDark};
    margin: ${theme.spacing(0, 1, 2, 1)};

    :hover {
      color: ${theme.colors.primary};
    }

    :focus-visible {
      outline: 2px solid ${theme.colors.primary};
      outline-offset: 2px;
      border-radius: 2px;
    }

    ${theme.media.md.up} {
      :not(:last-child) {
        border-right: 1px solid ${theme.colors.primaryDark};
        padding-right: ${theme.spacing(2)};
      }

      font-size: ${theme.fontSizes.h5};
    }
  `}
`;
